import apiClient from "./apiClient";
import {
  getEmail,
  getOrgCode,
  getOrgName,
  getUserName,
} from "../components/shared/util";
const PEOPLE_PATH = "/api/v3/teams";

export const getAllTeamsApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/getAllTeams`, data);
  return response.data;
};

export const addToTeamApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/addToTeam`, data);
  return response.data;
};
export const getTeamLeadNamesApi = async (name) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/getTeamLeadNames`,
    name
  );
  return response.data;
};
export const createTeamApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/createTeam`, data);
  return response.data;
};

export const getTeamByIdApi = async (teamId) => {
  const response = await apiClient.get(
    `${PEOPLE_PATH}/getTeamById?teamId=${teamId}`
  );
  return response.data;
};

export const removeFromTeamApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/removeFromTeam`, data);
  return response.data;
};

export const updateTeamApi = async (data) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/updateTeam`, data);
  return response.data;
};

export const deleteTeamApi = async (teamId) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/deleteTeam`, {
    teamId: teamId,
  });
  return response.data;
};

export const getSkillsByTeamDescApi = async (teamData) => {
  const response = await apiClient.post(
    `${PEOPLE_PATH}/getSkillsByTeamDescAndCulture`,
    teamData
  );
  return response.data;
};
